import "./banner/Banner.css";
import Banner from "./banner/Banner";
import {
  faBars,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popular_Product from "./popular_product/Popular_Product";
import "./Home.css";
import Explore_By_Category from "./explore_by_category/Explore_By_Category";
import Offers_Slider from "./offers_slider/Offers_Slider";
import Home_product_slider from "./home_product_slider/Home_product_slider";
import Common_Product_Swiper from "../common_components/common_product_swiper/Common_Product_Swiper";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAddBanner,
  getCoupons,
  getOfferProduct,
} from "../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllPopulerProduct,
  getAllProductsSeasonable,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import Common_todays_offer_swiper from "../common_components/common_todays_offer_swiper/Common_todays_offer_swiper";
import Bestseller_product_slider from "./bestseller_product_slider/Bestseller_product_slider";
import Home_Explore_By_Category from "./home_Explore_By_Category/Home_Explore_By_Category";
import Offer_Banner from "./offer_banner/Offer_Banner";

function Home() {
  const dispatch = useDispatch();
  const [categoryId, setCategoryId] = useState();
  const [subCategoryId, setSubCategoryId] = useState(null);
  const coupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    dispatch(getCoupons(100));
  }, []);

 

  const navigate = useNavigate();

  const categoryWiseProduct = useSelector(
    (state) => state.product.allProductsGroup
  );

  useEffect(() => {
    dispatch(getGroupByProduct({}));
  }, [dispatch]);

  const addBanners = useSelector((state) => state.home.addBanners);

  useEffect(() => {
    dispatch(getAddBanner());
  }, [dispatch]);

  const PopulerProducts = useSelector(
    (state) => state.product.allPopulerProducts
  );

  useEffect(() => {
    dispatch(getAllPopulerProduct({}));
  }, [dispatch]);

  const offerProducts = useSelector((state) => state.home.all_offer_product);

  useEffect(() => {
    dispatch(getOfferProduct());
  }, [dispatch]);

  const SeasonableProducts = useSelector(
    (state) => state.product.allProductsSeasonable
  );

  useEffect(() => {
    dispatch(getAllProductsSeasonable({}));
  }, [dispatch]);

  return (
    <section className="Home">
      <div className="container">
        <div className="desktop_view">
          <div className="row me-0 ms-0 ">
            <div className="col-12">
              <div className="body_container">
                <Banner />
                <Home_Explore_By_Category
                  categoryId={categoryId}
                  setCategoryId={setCategoryId}
                />

                {/* {coupons?.data?.length  > 0 && ( */}
                <Offers_Slider coupons={coupons} />
                {/* )} */}
                {Array.isArray(PopulerProducts?.data) &&
                  PopulerProducts.data.length > 0 && (
                    <Home_product_slider data={PopulerProducts.data} />
                  )}

                {/* {Array.isArray(offerProducts?.data) && offerProducts?.data > 0 && ( */}
                  <Common_todays_offer_swiper data={offerProducts} />
                {/* )} */}

                {Array.isArray(SeasonableProducts) &&
                  SeasonableProducts.length > 0 && (
                    <Bestseller_product_slider
                      data={SeasonableProducts}
                    />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
